import type { RouteRecordRaw } from "vue-router";
import { usePosOrderStore } from "@appstore/pos-order-store";

const PosOrderView = () => import("@views/pos-order/pos-order-view.vue");
const Step1View = () => import("@views/pos-order/step-1-view.vue");
const Step2View = () => import("@views/pos-order/step-2-view.vue");
const Step3View = () => import("@views/pos-order/step-3-view.vue");
const Step4View = () => import("@views/pos-order/step-4-view.vue");
const PosOrderEndView = () => import("@views/pos-order/pos-order-end-view.vue");
import suspectPerson from '@app/assets/images/components/icon-btn-sumljiva-oseba.svg';

export function guardPosOrderStep(step: number) {
    const flowState = usePosOrderStore().AppState;
    // if (step > allowedStep.number) {
    //     return { name: allowedStep.routeName };
    // }
    return true;
}

export const posOrderRoutes: RouteRecordRaw[] = [
    {
        component: PosOrderView,
        name: "posOrder_home",
        path: "pos-order",
        beforeEnter: (_to, from) => {
            if (from.matched.length === 0) {
                return { name: "dashboard_dashboard", replace: true };
            }

            return true;
        },
        redirect: {
            name: "PosOrderStep1"
        },
        children: [
            {
                path: "step-1",
                name: "PosOrderStep1",
                component: Step1View,
                beforeEnter: () => guardPosOrderStep(1),
                meta: {
                    stepId: 1,
                    buttons: [
                        {
                            name: "Cancel",
                            action: "cancel",
                            label: "Cancel",
                            class: "default-outline",
                            visible: true
                        },
                        {
                            name: "Next",
                            action: "validateStep1",
                            label: "Next",
                            visible: true
                        }
                    ],
                    navigation: {
                        nextStep: "PosOrderStep2",
                        contractlist: "pogodbe_seznam",
                    }
                },
            },
            {
                path: "step-2",
                name: "PosOrderStep2",
                component: Step2View,
                beforeEnter: () => guardPosOrderStep(2),
                meta: {
                    stepId: 2,
                    buttons: [
                        {
                            name: "Next",
                            action: "validateStep2",
                            label: "Next",
                            visible: true
                        }
                    ],
                    icons: [
                        { image: suspectPerson, name: "suspectPerson", class: "btn btn--primary-outline btn--round", action: "suspectPerson", visible: true }
                    ],
                    navigation: {
                        nextStep: "PosOrderStep3",
                        end: "PosOrderEnd",
                        contractlist: "pogodbe_seznam",
                    }
                },
            },
            {
                path: "step-3",
                name: "PosOrderStep3",
                component: Step3View,
                beforeEnter: () => guardPosOrderStep(3),
                meta: {
                    stepId: 3,
                    buttons: [
                        {
                            name: "UpdateData",
                            action: "updateData",
                            label: "UpdateData",
                            class: "default-outline",
                            visible: false
                        },
                        {
                            name: "SignVloga",
                            action: "signApplication",
                            label: "SignVloga",
                            visible: true
                        }
                    ],
                    navigation: {
                        nextStep: "PosOrderStep4",
                        end: "PosOrderEnd",
                    }
                },
            },
            {
                path: "step-4",
                name: "PosOrderStep4",
                component: Step4View,
                beforeEnter: () => guardPosOrderStep(4),
                meta: {
                    stepId: 4,
                    buttons: [
                        {
                            name: "Next",
                            action: "signContract",
                            label: "SignContract",
                            visible: true
                        }
                    ],
                    navigation: {
                        end: "PosOrderEnd",
                    }
                },
            },
            {
                path: "end",
                name: "PosOrderEnd",
                component: PosOrderEndView,
                meta: {
                    stepId: -1,
                    buttons: [
                        {
                            name: "ToContractList",
                            action: "close",
                            label: "ToContractList",
                            visible: true
                        }
                    ],
                    navigation: {
                        contractlist: "pogodbe_seznam",
                    }
                },
            },
        ],
    }
];
